













































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { E_Buttons } from '../../service/caseTime.types';

@Component({
    name: 'CaseTimeButton',
})
class CaseTimeButtonImpl extends Vue {
    @Prop({
        required: true,
        type: String,
        default() {
            return E_Buttons.Start
        }
    })
    type!: E_Buttons

    E_Buttons = E_Buttons
}

export default CaseTimeButtonImpl;
